import { useEffect } from "react";
import { useGlobalContext } from "../../context/Appcontext";
import { useLocation } from "react-router-dom";
import styles from "./Body.module.css";
// icons
import regenrateIcon from "../../assets/regenerate.svg";
import copyIcon from "../../assets/copy.svg";
import drBot from "../../assets/drBot.png";
import salesBot from "../../assets/salesBot.png";

const Body = () => {
  const { messages, processing, lastMsg,handleRegenerate } = useGlobalContext();
  const location = useLocation();

  const botImage = location.pathname === "/sales" ? salesBot : drBot;


  const formatMessage = (msg: any) => {
    // Handle different message structures
    const text = typeof msg.message === 'string'
      ? msg.message
      : msg.message?.response_text || msg.text || '';

    const from = (msg.role === 'assistant' || msg.role === 'ai') ? 'ai' : 'human';

    return { text, from };
  };


  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).catch((err) => console.error("Failed to copy:", err));
  };
  

  useEffect(() => {
    if (processing && lastMsg?.current) {
      lastMsg.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [processing]);

  return (
    <div className={styles.bodycontainer}>
      {messages.map((msg, index) => {
        const formattedMsg = formatMessage(msg);
        const isLastMessage = index === messages.length - 1;

        return (
          <div key={index}>
            <div
              className={`${styles.message} ${formattedMsg.from === "ai" ? styles.mLeft : styles.mRight}`}
              key={index}
            >
              {formattedMsg.from === "ai" && (
                <div>
                  <div className={styles.image}>
                    <img src={botImage} alt="AI" />
                  </div>
                </div>
              )}
              <p className={`${styles.text} ${formattedMsg.from === "ai" ? styles.botMessage : styles.userMessage}`}>
                {formattedMsg.text}
              </p>
            </div>
            {isLastMessage && formattedMsg.from === "ai" && (
              <div className={styles.buttonContainer}>
                <button
                  onClick={() => handleRegenerate()}
                  className={styles.regenerateButton}
                >
                  <img src={regenrateIcon} alt="Regenerate" />
                </button>
                <button
                  onClick={() => copyToClipboard(formattedMsg.text)}
                  className={styles.regenerateButton}
                >
                  <img src={copyIcon} alt="Copy" />
                </button>
              </div>
            )}
          </div>
        );
      })}

      {processing && (
        <div className={styles.processing}>
          <div className={styles.image}>
            <img src={botImage} alt="AI" />
          </div>
          <div className={styles.typing}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
          </div>
        </div>
      )}

      <div ref={lastMsg} />
    </div>
  );
};

export default Body;